module.exports = __webpack_public_path__ + "img/parts.fac560ec.jpg";